/** @jsx h */
import { createImageUrl } from '@nrk/serum-imagecrop-utils';
import { h } from 'preact';
import PureComponent from '../../lib/preact-pure-component';
import { createResponsiveSrcSet } from '../helpers';

class SerumResponsivePicture extends PureComponent {
  render() {
    const _this$props = this.props,
          className = _this$props.className,
          alt = _this$props.alt,
          id = _this$props.id,
          quality = _this$props.quality,
          ratio = _this$props.ratio,
          sizes = _this$props.sizes;
    const defaultUrl = createImageUrl({
      id,
      width: 1600,
      quality,
      ratio: ratio || '16:9'
    });
    const horizontalSourceSet = createResponsiveSrcSet({
      id,
      quality,
      ratio: ratio || '16:9'
    });
    return h("picture", {
      className: className
    }, h("source", {
      srcSet: horizontalSourceSet,
      sizes: sizes
    }), h("img", {
      src: defaultUrl,
      alt: alt,
      sizes: sizes
    }));
  }

}

export default SerumResponsivePicture;